/** @jsxImportSource @emotion/react */
import { ElementType } from 'react';
import { TypographyProps } from '@mui/material';
import QSTypography from '../typography';

export type QSTagProps<P extends ElementType<any>> = TypographyProps<
  P,
  {
    tagFontColorCode: string;
    tagBgColorCode: string;
    tag: string;
    component?: P;
  }
>;

function QSTag<P extends ElementType<any> = 'span'>({
  tagFontColorCode,
  tagBgColorCode,
  tag,
  sx,
  component,
  ...props
}: QSTagProps<P>) {
  return (
    <QSTypography
      sx={{
        display: 'inline-block',
        fontSize: '12px',
        fontWeight: 400,
        whiteSpace: 'nowrap',
        color: `${tagFontColorCode}`,
        background: `${tagBgColorCode}`,
        padding: '4px 6px',
        borderRadius: '4px',
        minWidth: 'min-content',
        ...sx,
      }}
      {...props}
    >
      {tag}
    </QSTypography>
  );
}

export default QSTag;
